import React from 'react';
import { Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { getDisplayValueForType } from '../../../../../../../../../../../../../utils/tableUtil';

import BaseDocumentCell from './BaseDocumentCell';

const UploadDateCell = ({ document }) => {
  if (!document) return null;

  return (
    <Text
      color="greyScale.600"
      key={document.id}
      textAlign="left"
      whiteSpace="nowrap"
      width="160px"
    >
      {getDisplayValueForType(document.createdAt, 'datetime')}
    </Text>
  );
};

UploadDateCell.propTypes = {
  document: PropTypes.shape({
    id: PropTypes.number,
    status: PropTypes.string,
    createdAt: PropTypes.string,
    statusLoading: PropTypes.bool
  })
};

export default BaseDocumentCell(UploadDateCell);
